module.exports = __webpack_public_path__ + "static/img/trianglify-max.35a20e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trianglify-max.jpg
// module id = 800
// module chunks = 2